module.exports = __webpack_public_path__ + "img/logo.6db6179f.svg";